/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Unnamed_GroupInputs */



/**
* | output |
* | --- |
* | "Unnamed Group" |
*
* @param {Team_Manager_Unnamed_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_unnamed_group = /** @type {((inputs?: Team_Manager_Unnamed_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Unnamed_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe sans nom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbenannte Gruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo senza nome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неназванная группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo sin nombre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未命名团体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前のないグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनाम समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo sem nome")
	return /** @type {LocalizedString} */ ("Unnamed Group")
});